import * as React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import StaticHero from "../components/v2/static-hero";
import ProjectCard from "../components/v2/project-card";
import Banner from "../components/v2/banner";
import useProjectsImages from "../hooks/useProjectsImages";
import StaticBanner from "../components/v2/static-banner";

const IndexPage = () => {
  return (
    <Layout
      className="homepage"
      bodyTheme="dark"
    >
      <SEO
        title="evo Campus Salt Lake"
        description="an evo x Lake Union Partners project"
      />
      <StaticHero />
      <div className="homepage__grid">
        <div className="homepage__cards homepage__cards--row-1">
          <div className="homepage__cards--column homepage__cards--row-1-c1">
            <ProjectCard imageData={useProjectsImages({name: "project-1"})} />
            <ProjectCard imageData={useProjectsImages({name: "project-2"})} />
          </div>
          <div className="homepage__cards--column homepage__cards--row-1-c2">
            <ProjectCard imageData={useProjectsImages({name: "project-3"})} />
            <ProjectCard
              theme="white"
              contentPosition="bottom-left"
              projectData={{
                title: "A launchpad for adventure",
                link: {
                  title: "evo Hotel",
                  url: "/evo-hotel/",
                }
              }}
            />
            <ProjectCard imageData={useProjectsImages({name: "project-5"})} imagePosition="right" />
          </div>
        </div>
        <div className="homepage__cards homepage__cards--row-2">
          <ProjectCard
            theme="dark"
            contentPosition="bottom-left"
            projectData={{
              title: "A Place for Our community",
              link: {
                title: "evo Salt Lake City",
                url: "/evo-salt-lake/",
              }
            }}
          />
          <ProjectCard imageData={useProjectsImages({name: "project-7"})} />
        </div>
        <div className="homepage__cards homepage__cards--row-3">
          <ProjectCard imageData={useProjectsImages({name: "project-8"})} />
          <ProjectCard imageData={useProjectsImages({name: "project-9"})} />
          <ProjectCard imageData={useProjectsImages({name: "project-10"})} />
        </div>
        <div className="homepage__cards homepage__cards--row-4">
          <Banner
            imageData={useProjectsImages({name: "project-19"})}
            imageDataHover={useProjectsImages({name: "project-19-hover"})}
            contentPosition="top-left"
            projectData={
              {
                link: {
                  title: "Bouldering Project",
                  url: "/bouldering-project/",
                }
              }
            }>
            <>
              <span>Real Movement<br /> Real Connection</span>
            </>
          </Banner>
        </div>
        <div className="homepage__cards homepage__cards--row-5">
          <ProjectCard imageData={useProjectsImages({name: "project-11"})} />
          <ProjectCard
            theme="dark"
            contentPosition="bottom-left"
            projectData={{
              title: "Built for Progression",
              link: {
                title: "All Together Skatepark",
                url: "/all-together-skatepark/",
              }
            }}
          />
        </div>
        <div className="homepage__cards homepage__cards--row-6">
          <div className="homepage__cards--column homepage__cards--row-6-c1">
            <ProjectCard imageData={useProjectsImages({name: "project-13"})} />
          </div>
          <div className="homepage__cards--column homepage__cards--row-6-c2">
            <ProjectCard imageData={useProjectsImages({name: "project-14"})} contentPosition="right" />
            <ProjectCard
              theme="white"
              contentPosition="bottom-left"
              projectData={{
                title: "Born in the Wasatch",
                link: {
                  title: "l9 Sports",
                  url: "/level-nine-sports/",
                }
              }}
            />
          </div>
        </div>
        <div className="homepage__cards homepage__cards--row-7">
          <Banner
            imageData={useProjectsImages({name: "project-20"})}
            imageDataHover={useProjectsImages({name: "project-20-hover"})}
            contentPosition="bottom-right"
            projectData={
              {
                link: {
                  title: "The Market Hall",
                  url: "/market-hall/",
                }
              }
            }>
            <>
              <span>Discover<br/> Something <br/> New</span>
            </>
          </Banner>
        </div>
        <div className="homepage__cards homepage__cards--row-8">
          <div className="homepage__cards--column homepage__cards--row-8-c1">
            <ProjectCard imageData={useProjectsImages({name: "project-16"})} />
            <ProjectCard
              theme="dark"
              contentPosition="bottom-left"
              projectData={{
                title: "Inspired by the outdoors",
                link: {
                  title: "The Art",
                  url: "/the-art/",
                }
              }}
            />
          </div>
          <div className="homepage__cards--column homepage__cards--row-8-c2">
            <ProjectCard imageData={useProjectsImages({name: "project-18"})} />
          </div>
        </div>
        <div className="homepage__cards homepage__cards--row-9">
          <StaticBanner imageData={useProjectsImages({name: "project-21"})} />
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage
